import { TFunction } from 'i18next'
import { OrganizationType } from 'types/organization'
import { z } from 'zod'

export const createOrganizationSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, {
      message: t('required'),
    }).max(255, {message: t('max-length-255')}),
    executiveOfficerName: z.string().min(1, {
      message: t('required'),
    }).max(255, {message: t('max-length-255')}),
    type: z.enum([
      OrganizationType.CLIENT,
      OrganizationType.TENDER_AUTHORITY,
    ]),
    userRequest: z.object({
      firstName: z.string().min(1, {
        message: t('required'),
      }).max(255, {message: t('max-length-255')}),
      lastName: z.string().min(1, {
        message: t('required'),
      }).max(255, {message: t('max-length-255')}),
      pin: z.string().min(1, {
        message: t('required'),
      }).max(255, {message: t('max-length-255')}),
      password: z.string().max(255, {message: t('max-length-255')}),
    })
  })
